import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import useAuth from "../hooks/useAuth";

const ProtectedRoute = ({ roles = [] }) => {
  const { isLoggedIn, user, gettingMe } = useAuth();

  if (gettingMe) return <Loader />;
  if (!isLoggedIn || roles.includes(user?.role)) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
